module.exports = __webpack_public_path__ + "static/media/i2.25733797.jpg";